import React, { Component } from 'react'

export default class Services extends Component {
  render() {
    return (
      <div>
  <section className="services style3 section">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-title">
            <h3 className="wow zoomIn" data-wow-delay=".2s">Services</h3>
            <h2 className="wow fadeInUp" data-wow-delay=".4s">What we offer</h2>
            <p className="wow fadeInUp" data-wow-delay=".6s">Do you want to become a developer or a programming, then take one of our tracks below to get started.Each track contains many courses, and you also have the liberty to choose the particular courses in each track that you want</p>
          </div>
        </div>
      </div>
      <div className="single-head">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".2s">
              <span className="serial">01</span>
              <h3><a href="track_details.html">Frontend Programming</a></h3>
              <p>This program includes the following courses: html5, css3, javascript, etc and you can choose....</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".4s">
              <span className="serial">02</span>
              <h3><a href="track_details.html">Backend Programming</a></h3>
              <p>We dejoy working with discerning clients, people for whom qualuty, service, integrity &amp;
                aesthetics.</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".6s">
              <span className="serial">03</span>
              <h3><a href="track_details.html">Graphics Design</a></h3>
              <p>We dejoy working with discerning clients, people for whom qualuty, service, integrity &amp;
                aesthetics.</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".2s">
              <span className="serial">04</span>
              <h3><a href="track_details.html">Software Development</a></h3>
              <p>We dejoy working with discerning clients, people for whom qualuty, service, integrity &amp;
                aesthetics.</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".4s">
              <span className="serial">05</span>
              <h3><a href="track_details.html">Data Analytics</a></h3>
              <p>We dejoy working with discerning clients, people for whom qualuty, service, integrity &amp;
                aesthetics.</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-service wow fadeInUp" data-wow-delay=".6s">
              <span className="serial">06</span>
              <h3><a href="track_details.html">UX &amp; UI Design</a></h3>
              <p>We dejoy working with discerning clients, people for whom qualuty, service, integrity &amp;
                aesthetics.</p>
              <div className="button">
                <a href="track_details.html" className="btn">Read More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

    )
  }
}
